module.exports = __webpack_public_path__ + "img/logo-WC-mark.0f5e04a2.svg";